import type {ValueProvider} from '../util/ValueProvider';

import {RefreshTriggerBase} from './RefreshTriggerBase';

export class TimeoutTrigger extends RefreshTriggerBase {
    intervalProvider: ValueProvider<number>;
    refresher: number | null = null;

    constructor(intervalProvider: ValueProvider<number>) {
        super();
        this.intervalProvider = intervalProvider;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init(visible: boolean) {

    }

    show() {
        const interval = 1000;
        if (this.refresher === null) {
            this.refresher = window.setInterval(() => {
                const value = this.intervalProvider.getValue();
                if (value === null || value === 0) {
                    return;
                }
                if ((this.getDurationSinceLastRefresh().elapsedMillis() > value * interval) && this.banner?.isInViewport()) {
                    this.refresh();
                }
            }, interval);
        }
    }

    hide() {
        if (this.refresher) {
            clearInterval(this.refresher);
        }
    }

    destroy() {

    }
}
